import { EditIcon } from '@chakra-ui/icons'
import { Box, Collapse, Flex, Text } from '@chakra-ui/react'
import { getHasPrimaryCoverage, getHasSecondaryCoverage, InsuranceInfo } from '@hb/shared'
import { useCallback, useMemo, useRef } from 'react'
import { useFormState } from 'react-final-form'
import { useResizeObserver } from '../../../../hooks/useResizeObserver'
import { ToggleButton } from '../../../Buttons/ActionButton'
import { useForm } from '../../FinalForm/FormProvider'
import { useFormWizard } from '../../FormWizard/context'

export const PlanIsMedicaid = ({ label }: { label: 'primary' | 'secondary' }) => {
  const { readOnly } = useFormWizard()
  const coveragePropName = useMemo(
    () => (label === 'primary' ? 'primaryCoverage' : 'secondaryCoverage'),
    [label],
  )
  // const { insuranceInfoData } = useInsuranceInfoStage()
  const { change, saveWithoutValidation } = useForm()
  const { values: data } = useFormState({ subscription: { values: true } })
  const option = data?.option
  const isMedicaidValue = data?.[coveragePropName]?.isMedicaid
  // const currIsMedicaidValue = insuranceInfoData?.[coveragePropName]?.isMedicaid

  const valueIsSet = useMemo(
    () => isMedicaidValue !== null && isMedicaidValue !== undefined && isMedicaidValue !== '',
    [isMedicaidValue],
  )
  const isMedicaidActive = useMemo(
    // () => !!insuranceInfoData.option && canHaveSecondaryOptions.includes(insuranceInfoData.option),
    () => {
      if (option === 'one-plan') return false
      if (option === 'medicaid') return false
      return label === 'primary'
        ? getHasPrimaryCoverage(data as Partial<InsuranceInfo>)
        : getHasSecondaryCoverage(data as Partial<InsuranceInfo>)
    },
    [option, label, data],
  )

  const handleSelect = useCallback(
    async (value: boolean | null) => {
      if (value === null) return change(coveragePropName, {})
      const existingIsMedicaid = data?.[coveragePropName]?.isMedicaid
      if (value && !existingIsMedicaid) {
        change(coveragePropName, { isMedicaid: true })
      } else if (!value && existingIsMedicaid) {
        change(coveragePropName, { isMedicaid: false })
      } else {
        change(coveragePropName, { isMedicaid: value })
      }
      await saveWithoutValidation(false)
    },
    [change, coveragePropName, data, saveWithoutValidation],
  )

  const ref = useRef<HTMLDivElement>(null)
  const { width } = useResizeObserver(ref, 'content')
  // const buttonWidth = useMemo(() => {
  //   const baseWidth = width / 2 - 5
  //   if (!valueIsSet) return baseWidth
  //   return baseWidth - 24
  // }, [width, valueIsSet])

  // const showButton = useMemo(
  //   () => !complete && valueIsSet && !submittedOn,
  //   [complete, valueIsSet, submittedOn],
  // )
  const nonMedicaidWidth = useMemo(() => {
    if (!valueIsSet) return width / 2 - 5
    return !isMedicaidValue ? width : 0 // - (showButton ? 48 : 0) : 0
  }, [width, valueIsSet, isMedicaidValue])

  const medicaidWidth = useMemo(() => {
    if (!valueIsSet) return width / 2 - 5
    return isMedicaidValue ? width : 0 // - (showButton ? 48 : 0) : 0
  }, [width, valueIsSet, isMedicaidValue])

  return (
    <Collapse in={isMedicaidActive} style={{ width: '100%' }}>
      <Flex ref={ref} py={1} w="100%" flexFlow="column" gap={1}>
        <Collapse in={!isMedicaidValue} style={{ width: '100%' }}>
          <Text fontSize="lg">Is your {label} plan Medicaid?</Text>
        </Collapse>
        <Flex
          pointerEvents={readOnly ? 'none' : 'auto'}
          position="relative"
          justifyContent="space-between"
          align="center">
          <Box
            opacity={nonMedicaidWidth ? 1 : 0}
            width={`${nonMedicaidWidth}px`}
            transition="all 0.3s ease-in-out">
            <ToggleButton
              onClick={e => {
                e.stopPropagation()
                if (valueIsSet) handleSelect(null)
                else handleSelect(false)
              }}
              minW={0}
              width="100%"
              transition="all 0.3s ease-in-out"
              isActive={isMedicaidValue === false}>
              Non-Medicaid
            </ToggleButton>
          </Box>
          <Box
            opacity={medicaidWidth ? 1 : 0}
            width={`${medicaidWidth}px`}
            transition="all 0.3s ease-in-out">
            <ToggleButton
              onClick={e => {
                e.stopPropagation()
                if (valueIsSet) handleSelect(null)
                else handleSelect(true)
              }}
              transition="all 0.3s ease-in-out"
              minW={0}
              width="100%"
              isActive={isMedicaidValue === true}>
              Medicaid
            </ToggleButton>
          </Box>
          <EditIcon
            position="absolute"
            right={4}
            color="white"
            pointerEvents="none"
            bg="transparent"
            filter="drop-shadow(0 0 2px rgba(0, 0, 0, 0.5))"
            opacity={valueIsSet && !readOnly ? 1 : 0}
            transition="all 0.3s ease-in-out"
          />
          {/* <Box
            transition="all 0.3s ease-in-out"
            opacity={showButton ? 1 : 0}
            pointerEvents={showButton ? 'auto' : 'none'}
            width={`${showButton ? 40 : 0}px`}>
            <IconButton
              borderRadius="full"
              onClick={handleEditClick}
              icon={<EditIcon />}
              aria-label="Edit"
            />
          </Box> */}
        </Flex>
      </Flex>
    </Collapse>
  )
}

// export const PrimaryIsMedicaid = ({ isComplete }: { isComplete: boolean }) => (
//   <PlanIsMedicaid label="primary" isComplete={isComplete} />
// )

// export const SecondaryIsMedicaid = ({ isComplete }: { isComplete: boolean }) => (
//   <PlanIsMedicaid label="secondary" isComplete={isComplete} />
// )
